import tabbyLogo from "@/assets/logos/tabby-logo.png";
import tamaraLogo from "@/assets/logos/tamara-logo.png";
import cashewLogo from "@/assets/logos/cashew-logo.png";
import emiratesNbdLogo from "@/assets/logos/emirates-nbd-logo.png";
import fabLogo from "@/assets/logos/fab-logo.png";
import duffelLogo from "@/assets/logos/duffel-logo.png";

export default function PartnerLogos() {
  const logos = [
    { name: "Tabby", src: tabbyLogo },
    { name: "Tamara", src: tamaraLogo },
    { name: "Cashew", src: cashewLogo },
    { name: "Emirates NBD", src: emiratesNbdLogo },
    { name: "FAB", src: fabLogo },
    { name: "Duffel", src: duffelLogo },
  ];
  
  return (
    <section className="py-10">
      <div className="max-w-6xl mx-auto px-4">
        <p className="text-sm uppercase tracking-wide text-muted-foreground mb-6">
          Backed by trusted names in finance
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-8 opacity-80">
          {logos.map(l => (
            <div key={l.name} className="flex items-center justify-center">
              <img src={l.src} alt={l.name} className="h-8 md:h-9 object-contain" />
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground mt-4">
          *Some integrations in pilot; additional partners launching soon.
        </p>
      </div>
    </section>
  );
}